module.exports = __webpack_public_path__ + "static/media/inactiveMessage.a6a276c2.svg";